import React, { useContext, useState, useEffect, useRef } from "react";
import { Tabs, Tab, Form, Dropdown, Button, Row, Col } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import swal from "sweetalert";
import {
  BASE_URL_API_TRANXT_API,
  BASE_URL_APISERVICES,
} from "../../utils/Constants";
import { GlobalContext } from "../../Context/GlobalState";
import { getLatLong } from "../../utils/utilFuctions";
import { cashWithdrawlSuccessPopup } from "../../utils/Models";
import { set } from "react-hook-form";

var convert = require("xml-js");

const CashWithdrawal = () => {
  const initialState = {
    bank: "",
    Aadhar: "",
    Device: "",
    Amount: "",
    mobile: "",
  };
  const [state, setState] = useState(initialState);
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [bankList, setBankList] = useState([]);
  const [encryptedData, setEncryptedData] = useState("");
  const [bankIin, setBankIin] = useState("");
  const [deviceInfo, setDeviceInfo] = useState(null);
  const [snackbarState, setSnackbarState] = useState({
    error: "",
    success: "",
  });
  const [protocall, setProtocall] = useState("http");
  const [bank, setBank] = useState({});
  const [devicePort, setDevicePort] = useState("11100");
  const [pidData, setPidData] = useState(null);
  const storedDevice = localStorage.getItem("device")
    ? localStorage.getItem("device")
    : -1;
  const [device, setDevice] = useState(0);
  const deviceOptions = [
    { value: 0, label: "Mantra MFS 100" },
    { value: 1, label: "Morpho MSO 1300" },
    { value: 2, label: "Startek FM220U" },
  ];

  const mantraPorts = [
    "11100",
    "11101",
    "11102",
    "11103",
    "11104",
    "11105",
    "11106",
  ];

  const discoverDevice = () => {
    let found = false;

    const protocalls = ["http", "https"];
    // https
    protocalls.forEach((p) => {
      for (let i = 0; i < mantraPorts.length && !found; i++) {
        const currentPort = mantraPorts[i];
        try {
          discoverDeviceReq(currentPort, p, () => {
            found = true;
            setDevicePort(currentPort);
            getDeviceInfo(currentPort, p);
            setProtocall(p);
          });
        } catch (error) {}
      }
    });
  };

  function getDeviceInfo(port, proto) {
    let url;
    if (device == 0) {
      url = `${proto}://localhost:${port}/rd/info`;
    }
    if (device == 1) {
      url = `${proto}://localhost:${port}/getDeviceInfo`;
    }
    if (device == 2) {
      url = `${proto}://localhost:${port}/rd/info`;
    }

    console.log(url);

    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    //
    xhr.open("DEVICEINFO", url, true);

    xhr.onreadystatechange = function () {
      // if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;

        if (status == 200) {
          var result1 = convert.xml2json(xhr.responseText, {
            compact: true,
            spaces: 4,
          });
          const data1 = JSON.parse(result1);
          if (
            data1.DeviceInfo?.additional_info?.Param[0]._attributes.value == ""
          ) {
            // alert('device is not ready');
            setSnackbarState({
              ...snackbarState,
              success: "",
              error: "device is not ready",
            });
          } else {
            setSnackbarState({
              ...snackbarState,
              success: "device is ready to use",
              error: "",
            });
            // alert('device is ready to use');
          }
          setDeviceInfo(data1);
        } else {
          console.log(xhr.response);
        }
      }
    };

    xhr.send();
  }

  const textStyle = {
    fontFamily: "Poppins",
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0em",
    textAlign: "left",
  };

  function discoverDeviceReq(port, proto, callback) {
    let url;
    if (device == 0) {
      url = `${proto}://localhost:${port}/rd/info`;
    }
    if (device == 1) {
      url = `${proto}://localhost:${port}/getDeviceInfo`;
    }

    if (device == 2) {
      url = `${proto}://localhost:${port}/rd/info`;
    }

    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    //
    xhr.open("DEVICEINFO", url, true);

    xhr.onreadystatechange = function () {
      // if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;

        if (status == 200) {
          var result1 = convert.xml2json(xhr.responseText, {
            compact: true,
            spaces: 4,
          });
          const data1 = JSON.parse(result1);
          console.log(data1);
          if (
            data1.DeviceInfo?.additional_info?.Param[0]._attributes.value == ""
          ) {
            // alert('device is not ready');
            // setSnackbarState({ ...snackbarState, success: "", error: "device is not ready" });
          } else {
            // setSnackbarState({ ...snackbarState, success: "device is ready to use", error: "" })
            // alert('device is ready to use');
            callback();
          }
          // setDeviceInfo(data1);
        } else {
        }
      }
    };

    xhr.send();
  }

  function mantraCapture(isKyc, callback) {
    var url = `${protocall}://localhost:${devicePort}/rd/capture`;
    let PIDOPTS = "";
    if (isKyc) {
      PIDOPTS =
        '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';
    } else {
      PIDOPTS =
        '<?xml version="1.0"?> <PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000" posh="UNKNOWN" env="P" wadh="" /> <CustOpts><Param name="mantrakey" value="undefined" /></CustOpts> </PidOptions>';
    }

    /*
        format=\"0\" --> XML
        format=\"1\" --> Protobuf
        */
    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    xhr.open("CAPTURE", url, true);
    xhr.setRequestHeader("Content-Type", "text/xml");
    xhr.setRequestHeader("Accept", "text/xml");

    xhr.onreadystatechange = function () {
      //if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;
        //parser = new DOMParser();
        if (status == 200) {
          var test1 = xhr.responseText;
          var test2 = test1.search("errCode");
          var test6 = getPosition(test1, '"', 2);
          var test4 = test2 + 9;
          var test5 = test1.slice(test4, test6);
          // conversion
          var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
          setPidData(JSON.parse(result1));
          if (test5 > 0) {
            setSnackbarState({
              ...snackbarState,
              error: xhr.responseText,
              success: "",
            });
            alert(xhr.responseText);
            //document.getElementById('text').value = xhr.responseText;
          } else {
            setSnackbarState({
              ...snackbarState,
              error: "",
              success: "Biometric captured successfully",
            });
            // alert("Captured Successfully");
            var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
            setPidData(JSON.parse(result1));
            if (callback) callback(JSON.parse(result1));
            //document.getElementById('text').value = "Captured Successfully";
          }
        } else {
        }
      }
    };

    xhr.send(PIDOPTS);
  }

  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }

  function startekCapture(isKyc, callback) {
    var url = `${protocall}://localhost:${devicePort}/rd/capture`;
    let PIDOPTS = "";
    if (isKyc) {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh=""/>' +
        "</PidOptions>";
    } else {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="" posh=""/>' +
        "</PidOptions>";
    }

    /*
        format=\"0\" --> XML
        format=\"1\" --> Protobuf
        */
    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    xhr.open("CAPTURE", url, true);
    xhr.setRequestHeader("Content-Type", "text/xml");
    xhr.setRequestHeader("Accept", "text/xml");

    xhr.onreadystatechange = function () {
      //if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;
        //parser = new DOMParser();
        if (status == 200) {
          var test1 = xhr.responseText;
          var test2 = test1.search("errCode");
          var test6 = getPosition(test1, '"', 2);
          var test4 = test2 + 9;
          var test5 = test1.slice(test4, test6);
          // conversion

          if (test5 > 0) {
            // alert(xhr.responseText);
            setSnackbarState({
              ...snackbarState,
              error: xhr.responseText,
              success: "",
            });
            //document.getElementById('text').value = xhr.responseText;
          } else {
            setSnackbarState({
              ...snackbarState,
              error: "",
              success: "Biometric captured successfully",
            });
            // alert("Captured Successfully");
            var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
            setPidData(JSON.parse(result1));
            if (callback) callback(JSON.parse(result1));
            //document.getElementById('text').value = "Captured Successfully";
          }
        } else {
        }
      }
    };

    xhr.send(PIDOPTS);
  }

  function morphoCapture(isKyc, callback) {
    var url = `${protocall}://localhost:${devicePort}/capture`;
    let PIDOPTS = "";
    if (isKyc) {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="E0jzJ/P8UopUHAieZn8CKqS4WPMi5ZSYXgfnlfkWjrc=" posh=""/>' +
        "</PidOptions>";
    } else {
      PIDOPTS =
        '<PidOptions ver="1.0">' +
        '<Opts fCount="1" fType="2" iCount="" iType="" pCount="" pType="" format="0" pidVer="2.0" timeout="10000" otp="" wadh="" posh=""/>' +
        "</PidOptions>";
    }

    /*
        format=\"0\" --> XML
        format=\"1\" --> Protobuf
        */
    var xhr;
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
      // If Internet Explorer, return version number
      //IE browser
      xhr = new window.ActiveXObject("Microsoft.XMLHTTP");
    } else {
      //other browser
      xhr = new XMLHttpRequest();
    }

    xhr.open("CAPTURE", url, true);
    xhr.setRequestHeader("Content-Type", "text/xml");
    xhr.setRequestHeader("Accept", "text/xml");

    xhr.onreadystatechange = function () {
      //if(xhr.readyState == 1 && count == 0){
      // fakeCall();
      //}
      if (xhr.readyState == 4) {
        var status = xhr.status;
        //parser = new DOMParser();
        if (status == 200) {
          var test1 = xhr.responseText;
          var test2 = test1.search("errCode");
          var test6 = getPosition(test1, '"', 2);
          var test4 = test2 + 9;
          var test5 = test1.slice(test4, test6);
          // conversion

          if (test5 > 0) {
            // alert(xhr.responseText);
            setSnackbarState({
              ...snackbarState,
              error: xhr.responseText,
              success: "",
            });
            //document.getElementById('text').value = xhr.responseText;
          } else {
            setSnackbarState({
              ...snackbarState,
              error: "",
              success: "Biometric captured successfully",
            });
            // alert("Captured Successfully");
            var result1 = convert.xml2json(test1, { compact: true, spaces: 4 });
            setPidData(JSON.parse(result1));
            if (callback) callback(JSON.parse(result1));
            //document.getElementById('text').value = "Captured Successfully";
          }
        } else {
        }
      }
    };

    xhr.send(PIDOPTS);
  }

  const capture = (isKyc, callback) => {
    if (
      !deviceInfo ||
      !deviceInfo.DeviceInfo ||
      !deviceInfo.DeviceInfo.additional_info ||
      deviceInfo.DeviceInfo.additional_info.Param.length == 0
    ) {
      // alert("Please choose device or check device is ready or not");
      setSnackbarState({
        ...snackbarState,
        error: "Please choose device or check device is ready or not",
        success: "",
      });
    } else if (
      device == 0 &&
      deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value != ""
    ) {
      setSnackbarState({ ...snackbarState, error: "", success: "" });
      mantraCapture(isKyc, callback);
    } else if (
      device == 1 &&
      deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value != ""
    ) {
      setSnackbarState({ ...snackbarState, error: "", success: "" });
      morphoCapture(isKyc, callback);
    } else if (
      device == 2 &&
      deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value != ""
    ) {
      setSnackbarState({ ...snackbarState, error: "", success: "" });
      startekCapture(isKyc, callback);
    } else {
      // alert("Please choose device or check device is ready or not");
      setSnackbarState({
        ...snackbarState,
        error: "Please choose device or check device is ready or not",
        success: "",
      });
    }
  };

  const validateForm = () => {
    // aepsCashWithdrawal();
    // if (
    // // state.bank == "" ||
    // state.Aadhar == ""
    // // state.Device == ""
    // ) {
    // swal("Invalid", "Please Fill Mandatory Fields", "error");
    // return;
    // } else if (state.Aadhar.length != 12) {
    // swal("Invalid", "Please Enter Valid Aadhaar Number", "error");
    // return;
    // }
    // aepsCashWithdrawal();
  };

  const clearForm = () => {
    setState(initialState);
  };

  const aepsCashWithdrawal = async (pidData) => {
    try {
      setTransactionLoaderState(true);
      const location = await getLatLong();
      const deviceData = getDeviceData();
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
        bankiin: bankIin,
        latitude: location[0],
        longitude: location[1],
        mobile: state.mobile,
        amount: state.Amount,
        captureType: "FINGER",
        biometricData: {
          encryptedAadhaar: state.Aadhar,
          errCode: pidData.PidData.Resp._attributes.errCode,
          errInfo: pidData.PidData.Resp._attributes.errInfo,
          fCount: pidData.PidData.Resp._attributes.fCount,
          fType: pidData.PidData.Resp._attributes.fType,
          iCount: pidData.PidData.Resp._attributes.iCount,
          iType: pidData.PidData.Resp._attributes.iType,
          pCount: pidData.PidData.Resp._attributes.pCount,
          pType: pidData.PidData.Resp._attributes.pType,
          pidDataType: pidData.PidData.Resp._attributes.pType,
          nmPoints: pidData.PidData.Resp._attributes.nmPoints,
          qScore: pidData.PidData.Resp._attributes.qScore.toString().trim() || "70",
          dpId: pidData.PidData.DeviceInfo._attributes.dpId,
          rdsId: pidData.PidData.DeviceInfo._attributes.rdsId,
          rdsVer: pidData.PidData.DeviceInfo._attributes.rdsVer,
          dc: pidData.PidData.DeviceInfo._attributes.dc,
          mi: pidData.PidData.DeviceInfo._attributes.mi,
          mc: pidData.PidData.DeviceInfo._attributes.mc,
          ci: pidData.PidData.Skey._attributes.ci,
          sessionKey: pidData.PidData.Skey._text,
          hmac: pidData.PidData.Hmac._text,
          PidDatatype: pidData.PidData.Data._attributes.type,
          pidData: pidData.PidData.Data._text,
          srno: deviceData.srno,
          sysid: deviceData.sysid,
          ts: deviceData.ts,
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}/api/AEPS/v1.0/Instantpay/aepsCashWithdrawal`,
        requestOptions
      );

      const data = await res.json();
      if (data.responseCode == "00") {
        // swal("Successful", data.responseMessage, "success");
        cashWithdrawlSuccessPopup(
          state.Aadhar,
          state.Amount,
          bank.name,
          data?.data?.externalRef,
          state.mobile,
          data?.data?.bankAccountBalance,
          () => {},
          () => {
            // capture(false, miniStatement);
          },
          "Cash Withdrawal"
        );
        clearForm();
      } else {
        swal("User Registration Failed", data.responseMessage, "error");
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
      swal("User Registration Failed", "Error From Server", "error");
    }
  };

  const getDeviceData = () => {
    // srno : deviceInfo.DeviceInfo.additional_info.Param[0]._attributes.value,
    const deviceData = {};
    deviceInfo.DeviceInfo.additional_info.Param.forEach((item) => {
      if (item._attributes.name == "srno") {
        deviceData.srno = item._attributes.value;
      }
      if (item._attributes.name == "sysid") {
        deviceData.sysid = item._attributes.value;
      }
      if (item._attributes.name == "ts") {
        deviceData.ts = item._attributes.value;
      }
    });

    return deviceData;
  };

  const getBankList = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: user.ReferId,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_APISERVICES}/api/AEPS/v1.0/Instantpay/getBankList`,
        requestOptions
      );
      const data = await res.json();
      if (data.responseCode === "00") {
        const formattedData = data.data.map((item) => ({
          label: item.name,
          value: item.iin,
        }));
        setBankIin(data.iin);
        setBankList(formattedData);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  console.log(bankIin);

  const AadharEncryption = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        aadhaar: state.Aadhar,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `https://bumppy.in/bumppypay/encryption.php`,
        requestOptions
      );
      const data = await res.json();
      setEncryptedData(data.data);
    } catch (error) {
      console.log("error", error);
    } finally {
      setTransactionLoaderState(false);
    }
  };

  useEffect(() => {
    // setSnackbarState({ error: "", success: "" });
    // console.log(deviceInfo);
    if (state.Device !== -1) discoverDevice();
  }, [state.Device]);

  useEffect(() => {
    if (state.Device !== -1) discoverDevice();
  }, [state.Device]);

  useEffect(() => {
    getBankList();
  }, []);

  return (
    <div style={{ padding: "1rem" }} className="bg-light ">
      <div style={{ borderRadius: "10px" }} className="card p-0 m-0 mx-2 mt-4 ">
        <div className="card-body m-0 p-3">
          <div>
            <div
              style={{
                fontFamily: "Poppins",
                fontSize: "32px",
                fontWeight: "600",
                lineHeight: "48px",
                letterSpacing: "0em",
                textAlign: "left",
                padding: "0px",
                background: "#FFFFFF",
                color: "#4267B2",
                fontWeight: "bolder",
                fontfamily: "Poppins !impotent",
                fontSize: "28px",
              }}
            >
              Cash Withdrawal
            </div>

            <div className="mt-2">
              <div className="col-10 m-0 p-0">
                <div className="row m-0 p-0">
                  <div className="col-6 p-0 pr-2 ">
                    <Form.Group>
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>
                          Customer Mobile No
                        </span>
                      </Form.Label>
                         <Form.Control
                                            type="text"
                                            maxLength="10"
                                            className="form-control rounded-100"
                                            aria-label="Notes"
                                            aria-describedby="basic-addon1"
                                            placeholder="Enter Mobile No"
                                            value={state.mobile}
                                            onChange={(e) => {
                                              const value = e.target.value.replace(/[^0-9]/g, "");
                                              setState({ ...state, mobile: value });
                                            }}
                                          />
                    </Form.Group>
                  </div>

                  <div className="col-6 p-0 pl-2 ">
                    <Form.Group className="rounded-100">
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>Select Bank</span>
                      </Form.Label>
                      <Select
                        options={bankList}
                        onChange={(e) => {
                          console.log(e);
                          setBank(e);
                          setBankIin(e.value);
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>

              <div className="col-10 m-0 p-0">
                <div className="row m-0 p-0">
                  <div className="col-6 p-0 pr-2">
                    {/* <Form.Group >
 <Form.Label>
 <span style={{ color: "red" }}>*</span>
 <span style={{ color: "black" }}>Enter Aadhar No</span>

 </Form.Label>
 <Form.Control
 type="text"
 className="form-control rounded-100"
 aria-label="Notes"
 aria-describedby="basic-addon1"
 placeholder="Enter Aadhar No"
 value={state.Aadhar}
 onChange={(e) => {
 setState({ ...state, Aadhar: e.target.value });
 }}

 />
 </Form.Group> */}
                    <Form.Group>
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>Enter Aadhar No</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        className="form-control rounded-100"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Aadhar No"
                        value={state.Aadhar}
                        onChange={(e) => {
                          const value = e.target.value;
                          setState({ ...state, Aadhar: value });
                          // AadharEncryption(value);
                        }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-6 p-0 pl-2 ">
                    <Form.Group className="rounded-100">
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>
                          Choose Biometric Device
                        </span>
                      </Form.Label>
                      <Select
                        options={deviceOptions}
                        value={state.Device}
                        onChange={(e) => {
                          setState({ ...state, Device: e });
                        }}
                      />
                    </Form.Group>
                  </div>
                </div>
              </div>
              <div className="col-10 m-0 p-0">
                <div className="row m-0 p-0">
                  <div className="col-6 p-0 pr-2">
                    {/* <Form.Group >
 <Form.Label>
 <span style={{ color: "red" }}>*</span>
 <span style={{ color: "black" }}>Enter Aadhar No</span>

 </Form.Label>
 <Form.Control
 type="text"
 className="form-control rounded-100"
 aria-label="Notes"
 aria-describedby="basic-addon1"
 placeholder="Enter Aadhar No"
 value={state.Aadhar}
 onChange={(e) => {
 setState({ ...state, Aadhar: e.target.value });
 }}

 />
 </Form.Group> */}
                    <Form.Group>
                      <Form.Label>
                        <span style={{ color: "red" }}>*</span>
                        <span style={{ color: "black" }}>Enter Amount</span>
                      </Form.Label>
                      <Form.Control
                        type="number"
                        className="form-control rounded-100"
                        aria-label="Notes"
                        aria-describedby="basic-addon1"
                        placeholder="Enter Amount"
                        value={state.Amount}
                        onChange={(e) => {
                          const value = e.target.value;
                          setState({ ...state, Amount: value });
                        }}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-6 p-0 pl-2 "></div>
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div className="">
            <div className="row">
              <div className="col-4 p-0 ml-2">
                <button
                  style={{
                    background: "#277BC0",
                    color: "white",
                    width: "60%",
                  }}
                  className="btn text-primary bg-white border-primary btn-block ml-2 "
                  onClick={() => {
                    capture(false, aepsCashWithdrawal);
                  }}
                >
                  {"Capture Fingerprint"}
                </button>
              </div>
              <div className="col-1"></div>
              <div className="col-2 p-0 ml-2">
                <Button
                  className="rounded-50 btn btn-primary btn-lg btn-block"
                  onClick={validateForm}
                >
                  {" "}
                  Submit
                </Button>
              </div>
              <div className="col-2 p-0 ml-2">
                <Button
                  className="rounded-50 btn border-primary btn-lg btn-block bg-white border text-primary"
                  onClick={clearForm}
                >
                  {" "}
                  Clear
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CashWithdrawal;
